import { useEffect } from "react"
import { retrieveAdvertise } from "../../Services/AdvertisementApiService";
import { useState } from "react";
import { useAuthHeader } from "../../auth/AuthService";

export default function Banner({width}) {
    const authHeader = useAuthHeader();
    const [data, setData] = useState([]);
    async function getAdvertise() {
        await retrieveAdvertise(authHeader())
        .then((response) => {
            let data = response.data.data;
            setData(data)
        })
        .catch((error) => console.log(error));
    }

    useEffect(() => {
        getAdvertise();
    }, []);

    return (
        <div className="col-8 flex align-items-center justify-content-end">
            { 
                data.map((v, i) =>  v.photo && <img key={i} src={process.env.REACT_APP_API_URL+'/file/'+v.photo} className={ width ?? "w-10"+ " hidden lg:block shadow-6"}/>)
            }
        </div>
    )
}